const CONSIDERATIONS = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Proximity to Trails and Waterfalls',
    body: 'Location is one of the most important factors for visitors planning to explore the area with a dog. Cabins within a short drive of trail access points or waterfalls tend to be the most convenient choice.',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Outdoor Space',
    body: 'A covered deck, porch, or wooded yard gives dogs a comfortable space to rest outside. Many Highlands cabins include covered outdoor living areas that work well for pet owners.',
  },
  {
    icon: 'ri-layout-line',
    title: 'Comfortable Interior Layout',
    body: 'A cabin with enough room for both guests and pets to move around comfortably makes for a more relaxed stay. Open floor plans and easy-to-clean surfaces are a practical consideration.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Access to Highlands and Nearby Attractions',
    body: 'Staying within a reasonable drive of downtown Highlands gives guests easy access to restaurants, shops, and services. Many pet-friendly cabins in the area offer this balance of seclusion and convenience.',
  },
];

export default function WhatToLookForSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Planning Your Stay</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light leading-tight mb-6">
              What to Look for in a<br /><em className="italic">Pet-Friendly Cabin</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-6">
              When choosing a cabin in Highlands, NC for a trip with a dog, a few practical considerations can make a significant difference. Here are the factors that travelers most often prioritize when selecting a pet-friendly cabin in this area.
            </p>
            <div className="rounded-2xl overflow-hidden h-[300px]">
              <img
                src="https://public.readdy.ai/ai/img_res/e159e875507c9f3b3540c558b816a0b2.jpg"
                alt="Mountain cabin porch in Highlands North Carolina overlooking a forested valley"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="space-y-5 pt-2">
            {CONSIDERATIONS.map((item) => (
              <div key={item.title} className="bg-[#FAFAF8] rounded-2xl p-6 flex gap-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#2D4A3E] text-base`} />
                </div>
                <div>
                  <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-1.5">{item.title}</h3>
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
